import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { worldClockCities } from '../data/bankData';
function formatTime(tz: string, now: Date) {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(now);
  } catch {
    return '--:--:--';
  }
}
const CYCLE_MS = 3000;
const VISIBLE = 2;
export function WorldClock() {
  const [now, setNow] = useState(new Date());
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(i => (i + 1) % worldClockCities.length);
    }, CYCLE_MS);
    return () => clearInterval(id);
  }, []);
  const window = Array.from({
    length: VISIBLE
  }, (_, o) => ({
    ...worldClockCities[(index + o) % worldClockCities.length],
    slot: o
  }));
  return <div className="flex items-center gap-2" data-id="element-157">
      <span className="text-[9px] uppercase tracking-[0.2em] text-white/55 font-semibold mr-1" data-id="element-158">
        World
      </span>
      {window.map(c => <div key={c.slot} className="relative overflow-hidden h-10 min-w-[120px]" style={{
      background: 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.14)',
      borderRadius: 6
    }} data-id="element-159">
          <AnimatePresence initial={false} mode="popLayout" data-id="element-160">
            <motion.div key={`${c.city}-${index}`} initial={{
          y: 28,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -28,
          opacity: 0
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1],
          delay: c.slot * 0.06
        }} className="absolute inset-0 flex items-center gap-2 px-3" data-id="element-161">
              <span className="text-lg leading-none" data-id="element-162">{c.flag}</span>
              <div className="flex flex-col leading-tight" data-id="element-163">
                <span className="text-[9px] uppercase text-white/70 font-semibold" data-id="element-164">
                  {c.city}
                </span>
                <span className="font-mono-num text-[13px] font-bold text-white" data-id="element-165">
                  {formatTime(c.tz, now)}
                </span>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>)}
    </div>;
}